import { fetchPrepr } from '@lib/prepr/prepr';
import ACTIVITY_PAGE_QUERY from '@lib/queries/activityPage';
import ACTIVITY_PAGES_QUERY from '@lib/queries/activityPages';
import { Activity } from '@type-declarations/overviewItems';
import { ActivityPage } from '@type-declarations/page';
import { QueryParameters } from '@type-declarations/prepr';
import { prepareDateForQuery } from '@utils/filters/dateFilter';

export interface ActivityPagesResponse {
  data: {
    ActivityPages: {
      items: Activity[];
      total: number;
    };
  };
}

export interface ActivityPageResponse {
  data: {
    ActivityPage: ActivityPage;
  };
}

/* Event pages */
export async function getActivityPages({
  page,
  title,
  tags,
  categories,
  date,
  locale,
  preview,
}: QueryParameters) {
  const res = await fetchPrepr<ActivityPagesResponse>({
    query: ACTIVITY_PAGES_QUERY({
      filterCategories: !!categories?.length,
      filterTags: !!tags?.length,
      filterTitle: !!title,
    }),
    variables: {
      page,
      title,
      tags,
      categories,
      locale,
      preview,
      ...prepareDateForQuery(date),
    },
  });

  return {
    items: res?.data?.ActivityPages.items || [],
    total: res?.data?.ActivityPages.total || 0,
  };
}

/* Event page */
export async function getActivityPage({
  id,
  slug,
  locale,
  preview,
  customerId,
}: QueryParameters) {
  const res = await fetchPrepr<ActivityPageResponse>({
    query: ACTIVITY_PAGE_QUERY,
    variables: { id, slug, locale, preview, customerId },
  });

  return res?.data?.ActivityPage;
}
